<template>
  <Card class="upsell-banner" :class="`upsell-banner--${alignment}`">
    <div>
      <h2>
        <slot name="title">{{ title }}</slot>
      </h2>
      <p>
        <slot name="description">{{ description }}</slot>
      </p>
    </div>
    <ButtonComponent :label="action" :icon="['fal', 'sparkles']" @click="$emit('action')" />
  </Card>
</template>

<script>
import Card from '@/components/Card'

export default {
  props: {
    title: String,
    description: String,
    action: String,
    alignment: {
      type: String,
      default: 'horizontal',
    },
  },
  components: { Card },
}
</script>

<style lang="scss">
.upsell-banner {
  background: linear-gradient(45deg, css-lightness('primary', 5%), css-lightness('primary', 25%));
  color: var(--primary-contrast);

  &--vertical {
    .card__content {
      flex-direction: column;
    }
  }

  .card__content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 2rem;
  }

  h2 {
    font-size: 1rem;
    margin: 0 0 3px 0;
  }

  p {
    margin: 0;
    opacity: 0.8;
  }

  a {
    color: inherit;
    text-decoration: underline;
  }

  .elder-button {
    background-color: rgba(white, 0.2);
  }
}
</style>
